/**
 * Vln API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum FileType {
    Video = 'video',
    VideoSlides = 'video_slides',
    VideoThumbnail = 'video_thumbnail',
    VideoForm = 'video_form',
    VideoSubtitles = 'video_subtitles',
    EventThumbnail = 'event_thumbnail',
    EventBanner = 'event_banner',
    OrganizationBanner ='organization_banner',
    OrganizationLogo = 'organization_logo',
    ProjectThumbnail = 'project_thumbnail',
    ProjectBanner = 'project_banner',
    ProjectLogo = 'project_logo'
}

